import React from "react";
import moment from "moment";
import {
	Table, Button, Modal, Spin, message, Input, Radio, TreeSelect, Select,
	Divider, Icon, Row, Col, Checkbox, DatePicker, Dropdown, Menu, Form
} from 'antd';

import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import userGroupService from '../../services/DailyReport/user-group-service'
import rosterService from '../../services/EmployeeManagement/roster-service.js';
import templateManagementService from '../../services/WorkReport/template-management-service';

@LayoutWrapper
@Form.create()
export default class GroupTemplateSetting extends React.Component {
	pageExist = true;
	state = {
		data: [],
		config: {},
		meta: {},
		pageStatus: "unload",
		configPageStatus: "unload",
		filters: {
			page: 1,
			employee_info: "",
		},
		currentData: {
			groups: []
		},
		currentIndex: false,
		selectedIDs: [],
		currentModalStatus: false,
		department: [],
		actionName: '',
		groupList: [],
		dayList: [],
		weekList: [],
		monthList: [],
		isEdit: false

	}

	columns = [{
		title: '工号',
		dataIndex: 'job_number',
		key: 'job_number',
		className: "table-global-head-small"
	}, {
		title: '姓名',
		dataIndex: 'real_name',
		key: 'real_name',
		className: "table-global-head-small",
	}, {
		title: '英文名',
		dataIndex: 'english_name',
		key: 'english_name',
		className: "table-global-head"
	}, {
		title: '操作',
		dataIndex: 'action',
		className: "table-global-head-tiny",
		key: 'action',
		render: (text, record) => (
			<span>
				{this.props.access.userGroup2.u_value && <Button icon="edit" size="small" onClick={this.handleEdit.bind(this, record.id)} >编辑</Button>}
			</span>
		)
	}]

	componentWillMount() {
		console.log(this.props)
		this.initializePage();
	}
	componentWillUnmount() {
		this.pageExist = false;
	}

	//初始化界面(查询)
	initializePage = () => this.setState({
		pageStatus: "reload"
	}, () => {
		const filters = {};
		for (let key in this.state.filters) {
			if (this.state.filters[key]) {
				filters[key] = this.state.filters[key];
			}
		}
		userGroupService.fetchGroupTemplateAll(filters, result => {
			if (this.pageExist) {
				this.setState({
					pageStatus: "loaded",
					data: result.data
				})
			}
		})
	})

	setEmployeeFilter = event => {
		this.setState({
			filters: {
				...this.state.filters,
				employee_info: event.target.value,
				page: 1
			}
		}, () => {
			if (!this.state.filters.employee_info) {
				this.initializePage()
			}
		})
	}

	//初始化下拉列表
	initList = () => {
		//群组
		userGroupService.fetchUserGroupList({}, result => {
			this.setState({
				groupList: result.data.Data
			})
		})

		//日周月报
		templateManagementService.selectTemplateManagement({}, result => {
			if (result.data.Success) {
				this.setState({
					dayList: result.data.Object.Data.filter(item => item.type_id === 1),
					weekList: result.data.Object.Data.filter(item => item.type_id === 2),
					monthList: result.data.Object.Data.filter(item => item.type_id === 3),
				});
			}
		})
	}

	//新增
	handleAdd = () => {
		this.setState({
			currentData: {},
			id: '',
			job_number: '',
			real_name: '',
			english_name: '',
			groups: [],
			day_template_id: '',
			week_template_id: '',
			month_template_id: '',
			currentModalStatus: true, actionName: '新增', isEdit: false
		});
		this.initList();
	}
	//编辑
	handleEdit = id => {
		this.setState({ currentModalStatus: true, actionName: '修改', isEdit: true });
		this.initList();
		userGroupService.fetchUserGroupTemplateList({ modelId: id }, result => {
			this.setState({
				groupList:this.state.groupList.concat(result.data.groups),
				id: result.data.id,
				job_number: result.data.job_number,
				real_name: result.data.real_name,
				english_name: result.data.english_name,
				groups: result.data.groups.map(item => item.id),
				day_template_id: result.data.day_template_id,
				week_template_id: result.data.week_template_id,
				month_template_id: result.data.month_template_id,
			});
		})
	}

	//批量删除
	handleDelete = () => {
		if (0 === this.state.selectedIDs.length) {
			message.error("请选择要删除的数据");
			return;
		}
		Modal.confirm({
			title: '确定删除这些数据么?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				userGroupService.deleteUserGroupTemplateList({ids: this.state.selectedIDs}, result => {
					if (result.data.Success) {
						this.setState({
							selectedIDs: []
						}, () => {
							message.success("删除成功", 4);
							this.initializePage();
						})
					}else{
						message.error("删除失败: " + result.data.Message, 4);
					}
				}, error => message.error("删除数据失败", 4))
			},
			onCancel: () => {}
		});
	}

	//modal切换显示
	toggleCurrentModal = () => this.setState({
		currentModalStatus: !this.state.currentModalStatus
	})
	//提交表单
	submitCurrentModal = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				let currentData = {
					id: this.state.id,
					...values,
				}
				if (currentData.id) {
					//修改
					userGroupService.updateGroupTemplate(currentData,result=>{
						if (result.data.Success) {
							this.toggleCurrentModal();
							message.success("修改数据成功", 4);
							this.initializePage();
						}else{
							if(result.data.Errors){
								message.error("添加数据失败 " + result.data.Errors[0], 4);
							}
							else{
								message.error("添加数据失败 " + result.data.Message, 4);
							}
							
						}
					})
				} else {
					//添加
					userGroupService.addGroupTemplate(currentData,result=>{
						if (result.data.Success) {
							this.toggleCurrentModal();
							message.success("添加数据成功", 4);
							this.initializePage();
						}else{
							if(result.data.Errors){
								message.error("添加数据失败 " + result.data.Errors[0], 4);
							}
							else{
								message.error("添加数据失败 " + result.data.Message, 4);
							}
							
						}
					})
				}

			}
		})
	}

	//工号改变事件
	changeJobNumber = value => {
		let text = value.target.value;
		if (!isNaN(text)) {
			rosterService.fetchEmployeesDetailByJobNumber({ job_number: text }, result => {
				if (result.data.Success) {
					this.setState({
						job_number: result.data.Object.job_number,
						real_name: result.data.Object.real_name,
						english_name: result.data.Object.english_name
					})
				}
			})
		}
	}
	//群组名称改变
	changeGroup = value => {
		userGroupService.fetchUserGroupList({ name: value }, result => {
			this.setState({
				groupList: result.data.Data
			})
		})
	}

	//复选框选中事件
	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
		  let ids = selectedRows.map(row => row.id);
		  this.setState({selectedIDs: ids});
		}
	  }
		setPageFilter = pagination => {
			this.state.filters.page=pagination.current;
			this.initializePage();
		}

	render() {
		return (
			<div className="app-module-item">
				<div style={{ float: "left" }}>
				</div>
				{this.props.access.groupTemplate.c_value &&
					<Button style={{ margin: "0px 5px 10px 0px" }}
						type="primary" icon="plus-circle-o"
						onClick={this.handleAdd.bind(this)}>
						新增
	</Button>}
				{this.props.access.groupTemplate.d_value &&
					<Button style={{ margin: "0px 5px 10px 0px" }}
						type="primary" icon="minus-circle-o"
						onClick={this.handleDelete}
					>
						批量删除
			</Button>}

				<div style={{ float: "right" }}>
					<Input.Search style={{ width: 200, margin: "0px 5px 10px 0px" }}
						placeholder="工号/中文名/英文名"
						onSearch={this.initializePage}
						onChange={this.setEmployeeFilter}
						value={this.state.filters.employee_info}
						enterButton />
				</div>
				<div style={{ clear: "both" }}></div>
				<Divider style={{ margin: "7px 0px 10px" }} />
				<div>
					{("unload" === this.state.pageStatus || "reload" === this.state.pageStatus) &&
						<div style={{ textAlign: 'center', margin: '100px 0px' }}>
							<Spin size="large" />
						</div>}
					{"loaded" === this.state.pageStatus &&
						<Table columns={this.columns}
							dataSource={this.state.data.Data}
							rowSelection={this.rowSelection}
							rowKey={record => record.id}
							pagination={{
								total: this.state.data.Total,
								pageSize: this.state.data.PageSize,
								current: this.state.filters.page
							}}
							onChange={this.setPageFilter} />}
				</div>

				{/* modal */}
				<Modal width="800px"
					visible={this.state.currentModalStatus}
					title={this.state.actionName}
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.submitCurrentModal} >
					<Form onSubmit={this.submitCurrentModal} className="login-form" layout="inline">
						<div style={{ marginBottom: "15px" }}>
							<Row>
								<Col span={8}>
									<Form.Item>
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;工号&nbsp;&nbsp;&nbsp;&nbsp;
									{this.props.form.getFieldDecorator('job_number', {
											rules: [{ required: true, message: '请输入工号' }],
											initialValue: this.state.job_number
										})(<Input style={{ width: "130px" }} onChange={this.changeJobNumber} disabled={this.state.isEdit} />)}
									</Form.Item>
								</Col>
								<Col span={8}>
									<Form.Item>
										中文名&nbsp;&nbsp;&nbsp;&nbsp;
									{this.props.form.getFieldDecorator('real_name', {
											rules: [{ required: true }],
											initialValue: this.state.real_name
										})(<Input style={{ width: "130px" }} disabled />)}
									</Form.Item>
								</Col>
								<Col span={8}>
									<Form.Item>
										英文名&nbsp;&nbsp;&nbsp;&nbsp;
									{this.props.form.getFieldDecorator('english_name', {
											initialValue: this.state.english_name
										})(<Input style={{ width: "130px" }} disabled />)}
									</Form.Item>
								</Col>
							</Row>
							<div className="Applys">
							{/* <Select
                               mode="multiple"
                               style={{ width: '600px' }}
                               placeholder="请输入群组名称"
							   onSearch={this.changeGroup}
                               notFoundContent={ null}
                               filterOption={false}
                               defaultValue={this.state.groups  ? this.state.groups  : []}
                           >
                                {
                                        this.state.groupList.map(i => <Select.Option key={i.id}>{i.name}</Select.Option>)
                                }
                            </Select> */}
								<Form.Item>
									发送群组&nbsp;&nbsp;&nbsp;&nbsp;
									{this.props.form.getFieldDecorator('groups', {
										rules: [{ required: true, message: '请输入群组名称' }],
										initialValue: this.state.groups
									})(
										<Select
											mode="multiple"
											style={{ width: "600px" }}
											filterOption={false}
											onSearch={this.changeGroup}
											placeholder="请输入群组名称">
											{this.state.groupList &&
												this.state.groupList instanceof Array &&
												this.state.groupList.map(group => {
													return (
														<Select.Option key={group.id} value={group.id}>
															{group.name}
														</Select.Option>
													)
												})}
										</Select>)}
								</Form.Item> 
							</div>
							<div className="Applys">
								<Form.Item>
									日报模板&nbsp;&nbsp;&nbsp;&nbsp;
									{this.props.form.getFieldDecorator('day_report_template', {
										initialValue: this.state.day_template_id
									})(
										<Select style={{ width: "270px" }}>
											{
												this.state.dayList.map(temp => (
													<Select.Option key={temp.id} value={temp.id}>
														{temp.name}
													</Select.Option>
												))}
										</Select>
									)}
								</Form.Item>
							</div>
							<div className="Applys">
								<Form.Item>
									周报模板&nbsp;&nbsp;&nbsp;&nbsp;
									{this.props.form.getFieldDecorator('week_report_template', {
										initialValue: this.state.week_template_id
									})(
										<Select style={{ width: "270px" }}>
											{
												this.state.weekList.map(temp => (
													<Select.Option key={temp.id} value={temp.id}>
														{temp.name}
													</Select.Option>
												))}
										</Select>
									)}
								</Form.Item>
							</div>
							<div className="Applys">
								<Form.Item>
									月报模板&nbsp;&nbsp;&nbsp;&nbsp;
									{this.props.form.getFieldDecorator('month_report_template', {
										initialValue: this.state.month_template_id
									})(
										<Select style={{ width: "270px" }}>
											{
												this.state.monthList.map(temp => (
													<Select.Option key={temp.id} value={temp.id}>
														{temp.name}
													</Select.Option>
												))}
										</Select>
									)}
								</Form.Item>
							</div>
						</div>
					</Form>
				</Modal>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/routes/DailyReport/GroupTemplateSetting.js